import React, { useContext } from 'react';
import { ContextServiceContent } from './Providers';
import { Carousel } from './Carousel';
import { Div } from './style';
import { useWltpComplianceGate } from '../useWltpComplianceGate';
import type { Logger } from '../feature-service-types';

export interface Props {
  isMarketComplianceEnabled?: boolean;
  initialCompliance?: boolean[];
  logger?: Logger;
}

export const App: React.FC<Props> = ({ isMarketComplianceEnabled, initialCompliance, logger }) => {
  const content = useContext(ContextServiceContent);
  const slideCompliance = useWltpComplianceGate({
    isMarketComplianceEnabled,
    initialCompliance,
    logger,
  });

  if (!content) return <Div data-testid="App" />;
  if (slideCompliance === null) return null;

  const visibleSlides =
    slideCompliance === undefined
      ? content.slides
      : content.slides.filter((_, i) => slideCompliance[i]);

  if (visibleSlides.length === 0 && slideCompliance !== undefined) return null;

  const contentToRender =
    visibleSlides.length === content.slides.length
      ? content
      : { ...content, slides: visibleSlides };
  const carouselKey = slideCompliance?.join(',') ?? 'all-slides';

  return (
    <Div data-testid="App">
      <Carousel key={carouselKey} data={contentToRender} />
    </Div>
  );
};
export default App;
